export const tableColumns = [
    {
        name: 'ID',
        selector: row => row.id,
        sortable: true,
        center: true,
        maxWidth: '1.375rem',
        style: {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    },
    {
        name: 'Previous fee amount',
        selector: row => row.previous_fee_amount,
        sortable: true,
        center: true,
        maxWidth: '9.375rem',
        style: {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    },
    {
        name: 'New fee amount',
        selector: row => row.convenience_fee_amount,
        sortable: true,
        center: true,
        maxWidth: '9.375rem',
        style: {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    },
    {
        name: 'Minimum transaction amount',
        selector: row => row.previous_min_amount,
        sortable: true,
        center: true,
        maxWidth: '9.375rem',
        style: {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    },
    {
        name: 'Annual fee increment',
        selector: row => row.convenience_increment,
        sortable: true,
        center: true,
        maxWidth: '9.375rem',
        style: {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    },
    {
        name: 'Modified by',
        selector: row => row.modified_by,
        sortable: true,
        center: true,
        maxWidth: '9.5rem',
        style: {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    },
    {
        name: 'Modified date',
        selector: row => row.modified_date,
        sortable: true,
        center: true,
        maxWidth: '9.5rem',
        style: {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    }
];